import { render, staticRenderFns } from "./BarraSimple.vue?vue&type=template&id=e2b1d1b6&scoped=true"
import script from "./BarraSimple.vue?vue&type=script&lang=js"
export * from "./BarraSimple.vue?vue&type=script&lang=js"
import style0 from "./BarraSimple.vue?vue&type=style&index=0&id=e2b1d1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b1d1b6",
  null
  
)

export default component.exports